<template>
  <v-app-bar flat color="#004984">
    <v-container class="fill-height d-flex align-center" fluid>
      <v-responsive max-width="120" class="me-15-custom">
        <router-link to="/projects">
          <v-img
            alt="SISGIP"
            :src="require('@/assets/img/logo_dark_nobg_app.png')"
          ></v-img>
        </router-link>
      </v-responsive>
      <v-spacer></v-spacer>

      <v-avatar class="me-4 ms-4" size="38">
        <!--me - margem à esquerda, ms à direita-->
        <template v-if="$store.state.img !== null">
          <v-img alt="Avatar" :src="$store.state.img"></v-img>
        </template>
        <template v-else>
          <v-img alt="Avatar" :src="UserImage"></v-img>
        </template>
      </v-avatar>
      <div class="d-none d-sm-block">
        <v-list-item-title class="name">{{
          $store.state.user
        }}</v-list-item-title>
        <v-list-item-title class="funcao">{{ this.func }}</v-list-item-title>
      </div>
      <v-menu :location="location">
        <template #activator="{ props }">
          <v-btn color="#004984" dark v-bind="props">
            <v-icon color="white" icon="mdi-menu-down"></v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item-title v-if="!isUsuarioTestador">
            <v-btn @click="showConfirmationModalGithub = true">
              Associar ao git
              <v-icon
                style="margin-left: 5px"
                color="black"
                icon="mdi-github"
              ></v-icon>
            </v-btn>
          </v-list-item-title>
          <v-menu
            v-if="!isUsuarioTestador"
            transition="slide-y-transition"
            :location="sublocation"
          >
            <template #activator="{ props }">
              <v-btn v-bind="props" style="width: 100%" variant="text">
                Mudar visão
                <v-icon
                  style="margin-left: 5px"
                  color="black"
                  icon="mdi-swap-horizontal"
                ></v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item-title>
                <v-btn
                  style="width: 100%"
                  @click="visualizarCoord()"
                  :disabled="!isCoord"
                >
                  Coordenador
                  <v-icon style="margin-left: 5px" color="black"></v-icon>
                </v-btn>
              </v-list-item-title>
              <v-list-item-title>
                <v-btn
                  style="width: 100%"
                  @click="visualizarDev()"
                  :disabled="!isDev"
                >
                  Desenvolvedor
                  <v-icon style="margin-left: 5px" color="black"></v-icon>
                </v-btn>
              </v-list-item-title>
              <v-list-item-title>
                <v-btn
                  style="width: 100%"
                  @click="visualizarScrum()"
                  :disabled="!isScrum"
                >
                  Scrum Master
                  <v-icon style="margin-left: 5px" color="black"></v-icon>
                </v-btn>
              </v-list-item-title>
            </v-list>
          </v-menu>
          <v-list-item-title>
            <v-btn style="width: 100%" @click="logout">
              Sair
              <v-icon
                style="margin-left: 5px"
                color="black"
                icon="mdi-logout-variant"
              ></v-icon>
            </v-btn>
          </v-list-item-title>
        </v-list>
      </v-menu>

      <!-- Confirmar associação ao github -->
      <v-dialog v-model="showConfirmationModalGithub" width="660px">
        <v-card>
          <v-card-title>
            <v-icon
              style="margin-right: 5px"
              color="black"
              icon="mdi-github"
            ></v-icon>
            <span>Associar ao GitHub</span>
          </v-card-title>
          <v-card-text>
            <p style="margin-bottom: 8px; text-align: justify">
              O SISGIP tem acesso apenas aos repositórios dentro da Organização
              <strong>{{ org }}</strong> liberados por um owner. Esse acesso não
              sobrepõe as permissões que o seu usuário possui dentro da
              organização. É possível revogar essa autorização ao SISGIP pelo
              Github.
            </p>

            <p><strong>Read and write:</strong></p>
            <ul style="margin-bottom: 8px; list-style-type: none">
              <li>- Membros e equipes de organizações</li>
              <li>
                - Criação, exclusão, configurações, equipes e colaboradores do
                repositório.
              </li>
              <li>
                - Issues e comentários, responsáveis, labels e milestones
                relacionados.
              </li>
            </ul>
            <p><strong>Write:</strong></p>
            <p>
              - Pesquisar repositórios, listar colaboradores e acessar os
              metadados do repositório.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="red"
              text
              @click="showConfirmationModalGithub = false"
            >
              Cancelar
            </v-btn>
            <v-btn color="#004984" text @click="associateGit">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app-bar>
</template>

<script>
import axios from 'axios';

import UserImage from '@/assets/img/img_padrao.jpg';
import store from '@/store/store';
// import ModalCadastrarProjeto from './dialogs/ModalCadastrarProjeto.vue';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  // components: {
  //   ModalCadastrarProjeto,
  // },
  data: () => ({
    // dialog: false,
    links: ['Dashboard', 'Messages', 'Profile', 'Updates'],
    UserImage: UserImage,
    location: 'bottom', // Define a abertura do dropdown
    sublocation: 'start', // Define a abertura do dropdown de visões
    showConfirmationModalGithub: false,
    org: undefined,
  }),
  computed: {
    func() {
      return this.$store.state.funcao;
    },
    isDev() {
      return localStorage.getItem('dev') === 'sim';
    },
    isCoord() {
      return localStorage.getItem('coord') === 'sim';
    },
    isUsuarioTestador() {
      return localStorage.getItem('usuarioTestador') === 'sim';
    },
    isScrum() {
      return localStorage.getItem('scrum') === 'sim';
    },
  },
  created() {
    this.fetchOrg();
  },
  methods: {
    /* eslint-disable */
    /**
     * Realiza a autenticação do usuário no Github e exibe a página de autorização.
     * @function
     * @name associateGit
     * @returns {void}
     * @throws {Error} Se não for possível autenticar o usuário.
     */
    associateGit() {
      /* TODO: Ver erro CONEXAO_REFUSED */
      axios
        .post(
          API_URL + '/usuarios/auth',
          {},
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        )
        .then((response) => {
          this.showConfirmationModalGithub = false;
          console.log(response);
          const url = response.data;
          window.open(url, '_blank');
        })
        .catch((error) => {
          console.error(error);
          this.showConfirmationModalGithub = false;
        });
      this.dialog = false;
    },
    /**
     * Redireciona o usuário para a página de criação de um novo projeto.
     * @function
     * @name newProject
     */
    newProject() {
      this.$router.push('/projects');
    },

    visualizarScrum() {
      localStorage.setItem('funcao', 'Scrum Master');
      this.$store.commit('setFuncao', 'Scrum Master');
      this.$router.push('/projectsScrum');
    },

    visualizarDev() {
      localStorage.setItem('funcao', 'Desenvolvedor');
      this.$store.commit('setFuncao', 'Desenvolvedor');
      this.$router.push('/projectsDev');
    },

    visualizarCoord() {
      localStorage.setItem('funcao', 'Coordenador');
      this.$store.commit('setFuncao', 'Coordenador');
      this.$router.push('/projectsCoord');
    },
    /**
     * Remove o token e variáveis de visões do usuário do localStorage, reseta o estado da store Vuex e redireciona o usuário para a página de login.
     * @function
     * @name logout
     */
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('dev');
      localStorage.removeItem('coord');
      localStorage.removeItem('scrum');
      store.commit('resetState');
      this.$router.push('/login');
    },
    fetchOrg() {
      axios
        .get(API_URL + '/projetos/org', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.org = response.data;
          this.$store.commit('setOrg', this.org);
          console.log(this.org);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
#inspire {
  background-color: #f9f8f8;
}
.class {
  background-color: white;
}
.v-container {
  padding: 6px;
}
.name {
  color: white;
  font-size: 16px;
}
.funcao {
  color: #b6b6b6;
  font-size: 14px;
}
.button-new {
  background-color: white;
  color: black;
  text-transform: capitalize;
}
@media (max-width: 599.98px) {
  .me-15-custom {
    margin-inline-end: 8px !important;
  }
}
@media (min-width: 600px) {
  .me-15-custom {
    margin-inline-end: 60px !important;
  }
}
</style>
